import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Confirm from 'react-confirm-bootstrap';
import { graphql, compose } from 'react-apollo';
import { FormattedMessage, injectIntl } from 'react-intl';

import CommonTable from '../../CommonTable/CommonTable';
import Link from '../../Link';
import CustomPagination from '../../CustomPagination';

import messages from '../../../locale/messages';

import SMTPModal from './SMTPModal/SMTPModal';
import { openSmtpSetupModal } from '../../../actions/siteadmin/modalActions';
import { updateSmtpActiveStatus } from '../../../actions/siteadmin/SmtpSetup/updateSmtpActiveStatus';
import { deleteSmtpSetup } from '../../../actions/siteadmin/SmtpSetup/manageSmtpData';
import { getFormData } from '../../../helpers/SmtpSetup/getFormData';
import { getAllSmtpData } from '../../../../lib/graphql/admin';

import s from './SMTPManagement.css';
import bt from '../../../components/commonStyle.css';

class SMTPManagement extends React.Component {

  static defaultProps = {
    data: []
  };

  handleModalOpen = (value) => {
    const { openSmtpSetupModal } = this.props;
    const formData = getFormData(value);
    if (value?.id) openSmtpSetupModal('edit', formData)
    else openSmtpSetupModal('add')
  }

  handleUpdate = async (id) => {
    const { updateSmtpActiveStatus, setStateVariable, currentPage, data: { refetch, getAllSmtpData } } = this.props;
    let variables = { currentPage: currentPage > 1 && getAllSmtpData?.results?.length == 1 ? currentPage - 1 : currentPage };
    await updateSmtpActiveStatus(id);
    this.setState({ currentPage: 1 });
    await setStateVariable(variables);
    await refetch(variables);
  }

  handleDelete = async (id) => {
    const { deleteSmtpSetup, setStateVariable, currentPage, data: { refetch, getAllSmtpData } } = this.props;
    let variables = { currentPage: currentPage > 1 && getAllSmtpData?.results?.length == 1 ? currentPage - 1 : currentPage };
    await deleteSmtpSetup({ id });
    this.setState({ currentPage: 1 });
    await setStateVariable(variables);
    await refetch(variables);
  }

  handleSearchChange(searchList) {
    const { data: { refetch }, setStateVariable } = this.props;
    let variables = {
      currentPage: 1,
      searchList,
    };
    setStateVariable(variables);
    refetch(variables);
  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.idLabel) },
      { data: formatMessage(messages.smtpName) },
      { data: formatMessage(messages.setActive) },
      { data: formatMessage(messages.status) },
      { data: formatMessage(messages.editLabel) },
      { data: formatMessage(messages.delete) }
    ]
  }

  tbody = (props) => {
    const { formatMessage } = this.props.intl;

    const { data: { getAllSmtpData } } = props;

    return getAllSmtpData?.results?.map((value, key) => {
      return {
        id: key,
        data: [
          { data: value?.id, },
          { data: value?.smtpName },
          { data: !value?.isActive && <Link noLink onClick={() => this.handleUpdate(value?.id)}><FormattedMessage {...messages.setAsActive} /></Link> },
          { data: value?.isEnable ? formatMessage(messages.enabledLabel) : formatMessage(messages.disabledLabel) },
          { data: <Link noLink onClick={() => this.handleModalOpen(value)}><FormattedMessage {...messages.editLabel} /></Link> },
          {
            data: <Confirm
              onConfirm={() => this.handleDelete(value?.id)}
              body={formatMessage(messages.areYouSureDeleteWishList)}
              confirmText={formatMessage(messages.confirmDelete)}
              cancelText={formatMessage(messages.cancel)}
              title={formatMessage(messages.deletingSMTP)}>
              <a href="javascript:void(0)"><FormattedMessage {...messages.delete} /></a>
            </Confirm>
          }
        ]
      }
    })
  }

  paginationData = (currentPage) => {
    const { data: { refetch }, setStateVariable } = this.props;
    let variables = { currentPage };
    setStateVariable(variables);
    refetch(variables);
  }

  render() {
    const { currentPage } = this.props;
    const { data: { getAllSmtpData } } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className={cx(s.pagecontentWrapper, 'pagecontentAR')}>
        <SMTPModal paginationData={this.paginationData} currentPage={currentPage} />
        <CommonTable
          thead={this.thead}
          tbody={() => this.tbody(this.props)}
          title={formatMessage(messages.smtpSetupLabel)}
          addAction={this.handleModalOpen}
          redirectionLabel={formatMessage(messages.addNewLabel)}
        />
        {
          getAllSmtpData?.count > 0 &&
          <CustomPagination
            total={getAllSmtpData?.count}
            currentPage={currentPage}
            defaultCurrent={1}
            defaultPageSize={10}
            change={this.paginationData}
            paginationLabel={formatMessage(messages.smtpSetupLabel)}
            isScroll
          />
        }
      </div>
    )
  }
}

const mapState = (state) => ({});

const mapDispatch = {
  openSmtpSetupModal,
  deleteSmtpSetup,
  updateSmtpActiveStatus
};

export default compose(
  injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch),
  graphql(getAllSmtpData, {
    options: (props) => ({
      variables: {
        currentPage: props.currentPage
      },
      fetchPolicy: 'network-only'
    })
  }),
)(SMTPManagement);